window.addEventListener('load', () => {
	initParallax();

	setTimeout(() => {
		ScrollTrigger.sort();
		ScrollTrigger.refresh();
	}, 100);
});

function initParallax() {
	const timelineSection = document.querySelector('.morning-night-section');
	const tabsSection = document.querySelector('.tabs-images-section');
	const imageHolder = document.querySelector('.morning-night__image-holder');

	if (!timelineSection || !tabsSection || !imageHolder) return;

	// Prepare structure for Parallax
	const parallaxHolder = document.createElement('div');

	parallaxHolder.classList.add('parallax-holder');

	timelineSection.parentNode.insertBefore(parallaxHolder, timelineSection);
	parallaxHolder.appendChild(imageHolder);
	parallaxHolder.appendChild(timelineSection);
	parallaxHolder.appendChild(tabsSection);

	// Register plugins
	gsap.registerPlugin(ScrollTrigger);

	// Init Parallax
	new Parallax(parallaxHolder);

	if (ScrollTrigger.isTouch === 1) {
		ScrollTrigger.config({
			ignoreMobileResize: true
		});

		// Enable normalizeScroll only on touch devices
		ScrollTrigger.normalizeScroll(true);
	}
}

/*
 * Parallax module
 */
class Parallax {
	constructor(holder, options) {
		this.options = {
			timelineSection: '.morning-night',
			timelineImagesHolder: '.morning-night__screen-images',
			tabsImagesHolder: '.tabs-images__frame',
			imageHolder: '.morning-night__image-holder',
			imageWrapper: '.morning-night__image-wrapper',
			tabsSection: '.tabs-images-section',
			tabsLinks: '.tabs-images__holder .accordion__btn-opener',
			slides: '.morning-night__block',
			anchorMenu: '.morning-night__menu-wrap',
			anchorLinks: '.morning-night__menu a',
			anchorLinksBackground: '.background-follow',
			activeClass: 'active',
			scaleTo: 1.4,
			xPercentShift: -40, // in percent
			yPercentShift: -13, // in percent
			...options
		};

		if (holder && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
			this.holder = holder;
			this.currentSlide = 0;
			this.lastWidth = window.innerWidth;

			this.init();
		}
	}

	init() {
		this.slides = this.holder.querySelectorAll(this.options.slides);
		this.anchorMenu = this.holder.querySelector(this.options.anchorMenu);
		this.anchorLinks = this.anchorMenu?.querySelectorAll(this.options.anchorLinks);
		this.anchorLinksBackground = this.anchorMenu?.querySelector(this.options.anchorLinksBackground);
		this.imageHolder = this.holder.querySelector(this.options.imageHolder);
		this.imageWrapper = this.imageHolder?.querySelector(this.options.imageWrapper);
		this.timelineSection = this.holder.querySelector(this.options.timelineSection);
		this.timelineImagesHolder = this.holder.querySelector(this.options.timelineImagesHolder);
		this.timelineImages = this.timelineImagesHolder?.querySelectorAll('img');
		this.tabsSection = this.holder.querySelector(this.options.tabsSection);
		this.tabsImagesHolder = this.holder.querySelector(this.options.tabsImagesHolder);
		this.tabsLinks = this.tabsSection?.querySelectorAll(this.options.tabsLinks);
		this.bgColorsArr = this.timelineSection?.getAttribute('data-bg-colors').split(',') || [];
		this.textColorsArr = this.timelineSection?.getAttribute('data-text-colors').split(',') || [];

		if (!this.imageHolder || !this.imageWrapper || !this.timelineSection || !this.slides.length || !this.tabsSection) return;

		this.slidesLength = this.slides.length;

		// Clone tabs images to image holder
		if (this.tabsImagesHolder) {
			const cloneHolder = this.tabsImagesHolder.cloneNode(true);

			this.tabsImagesHolder = cloneHolder;

			this.imageWrapper.appendChild(cloneHolder);
			this.tabsImages = cloneHolder.querySelectorAll('img');
		}

		// Initial state
		this.timelineImagesHolder.classList.add(this.options.activeClass);

		this.attachEvents();
	}

	attachEvents() {
		this.resizeHandler();
		this.initScrollHandler();
		this.updateStates();

		// Switch sections on click on anchors
		this.anchorLinks?.forEach((link, i) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();

				this.scrollToSlide(link);
			});
		});

		// Switch images on click on tabs
		this.tabsLinks?.forEach((link, i) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();

				this.tabsImages.forEach((image, index) => {
					image.classList.toggle(this.options.activeClass, index === i);
				});
			});
		});

		this.animateHoverBackground(this.anchorLinks?.[0]);

		this.onResize = Parallax.debounce(() => {
			const currentWidth = window.innerWidth;

			if (currentWidth === this.lastWidth) return;

			this.lastWidth = currentWidth;
			this.resizeHandler();
		}, 250);

		window.addEventListener('resize', this.onResize);
	}

	initScrollHandler() {
		const winHeight = window.innerHeight;

		// Timeline section animation
		gsap.timeline({
			ease: 'none',
			scrollTrigger: {
				id: 'parallaxTrigger',
				trigger: this.timelineSection,
				start: 'top top',
				end: () => `+=${this.slidesLength * winHeight}`,
				pin: true,
				pinSpacing: true,
				scrub: true,
				onUpdate: ({ progress }) => {
					const valuePerSlide = 1 / this.slidesLength;
					const index = Math.min(this.slidesLength - 1, Math.max(0, Math.round(progress / valuePerSlide)));

					if (this.currentSlide !== index) {
						this.currentSlide = index;

						this.updateStates();
					}
				}
			}
		});

		// Image holder animation
		gsap.to(this.imageWrapper, {
			scale: this.options.scaleTo,
			xPercent: this.options.xPercentShift,
			yPercent: this.options.yPercentShift,
			ease: 'none',
			scrollTrigger: {
				trigger: this.tabsSection,
				start: 'top bottom',
				end: 'top top',
				scrub: true,
				onUpdate: ({ progress }) => {
					if (progress < 0.5) {
						this.timelineImagesHolder.classList.add(this.options.activeClass);
						this.tabsImagesHolder.classList.remove(this.options.activeClass);
					} else {
						this.timelineImagesHolder.classList.remove(this.options.activeClass);
						this.tabsImagesHolder.classList.add(this.options.activeClass);
					}
				}
			}
		});

		this.resizeHandler();
	}

	updateStates() {
		this.slides.forEach((slide, i) => {
			slide.classList.toggle(this.options.activeClass, i === this.currentSlide);
		});

		this.anchorLinks?.forEach((link, i) => {
			link.classList.toggle('active', i === this.currentSlide);
		});

		if (this.bgColorsArr.length) {
			this.holder.style.setProperty('--bg-color', this.bgColorsArr[this.currentSlide]);
		}

		if (this.textColorsArr.length) {
			this.holder.style.setProperty('--text-color', this.textColorsArr[this.currentSlide]);
		}

		this.timelineImages.forEach((image, i) => {
			image.classList.toggle('active', i === this.currentSlide);
		});

		this.animateHoverBackground(this.anchorLinks[this.currentSlide]);
	}

	scrollToSlide(link) {
		const href = link.getAttribute('href');
		const targetId = href.startsWith('#') ? href.substring(1) : href;
		const targetSlide = this.holder.querySelector(`#${targetId}`);

		if (!targetSlide) return;

		const index = Array.from(this.slides).indexOf(targetSlide);
		const trigger = ScrollTrigger.getById('parallaxTrigger');

		if (index === -1 || !trigger) return;

		const totalScroll = trigger.end - trigger.start;
		const perSlideScroll = totalScroll / this.slidesLength;
		const targetScroll = trigger.start + perSlideScroll * index;

		// Scroll to active section
		window.scrollTo({
			top: targetScroll,
			behavior: 'smooth'
		});
	}

	animateHoverBackground(link) {
		if (!link || !this.anchorLinksBackground || !this.anchorMenu) return;

		const linkRect = link.getBoundingClientRect();
		const wrapRect = this.anchorMenu.getBoundingClientRect();
		const left = linkRect.left - wrapRect.left;
		const top = linkRect.top - wrapRect.top;
		const width = linkRect.width;

		gsap.to(this.anchorLinksBackground, {
			x: left,
			y: top,
			width: width,
			duration: 0.4,
			ease: 'power2.out'
		});
	}

	resizeHandler() {
		requestAnimationFrame(() => {
			ScrollTrigger.refresh();

			this.animateHoverBackground(this.anchorLinks[this.currentSlide]);

			this.holder.style.setProperty('--timeline-height', `${window.innerHeight * (this.slidesLength + 1)}px`);
		});
	}

	static debounce(func, delay = 250) {
		let timer = null;

		return function(...args) {
			clearTimeout(timer);

			timer = setTimeout(() => func.apply(this, args), delay);
		};
	}
}
